import { WorkerClientProvider } from "@main/providers/worker-client-provider";
import type { ParentProps } from "solid-js";

/**
 * §5.2 / §UC-08 / URL 設計: `/session` と `/permission-denied` を覆う Layout route。
 * worker の Provider をここで一括 mount することで、 page 跨ぎ遷移 (例: 権限拒否 →
 * /permission-denied → 再取得 → /session) で Provider が unmount せず resource を維持できる。
 *
 * 主な効果:
 * - セッション開始で起動した worker をそのまま session で使える (= MediaPipe wasm 再ロードを
 *   避けてオーバーヘッド削減)
 * - `/session` 完了 (handleStop) で `/sessions/:id` に navigate されると Layout 自体が
 *   unmount → Provider が onCleanup で resource を release する
 *
 * camera は app-layout root の `CameraProvider` で保持され、 SessionFlowLayout の責務外。
 * issue #130 以後: audio capture provider は撤去された (= vision-VAD 統一)。
 */
export function SessionFlowLayout(props: ParentProps) {
  return <WorkerClientProvider>{props.children}</WorkerClientProvider>;
}
